import lhServerClient from ".";
import { CustomizationType } from "./enum";

export interface DiyRuleGroup {
    id: number;
    name: string;
    index: number;
    dataCreated: string;
    lastUpdated: string;
    /**
     * c端每行显示的个数  如果为空默认显示4个
     */
    numPerLine?: number;

    type: CustomizationType;
}

export async function getDiyRuleGroupList(type = CustomizationType.CELL_PHONE_CUSTOMIZATION): Promise<DiyRuleGroup[]> {
    return lhServerClient.get("/diy_rule_group/list", {
        type,
    });
}
